import { XmlCursorPos, XMLCursorPositions } from '../cursor/xmlCursorPos.class';
import { XmlRules } from '../xml-rules-check/xmlRules.class';
import { XmlEditRuleCheckTextInsert } from '../xml-rules-check/xmlEditRuleCheckTextInsert.class';
import { XmlSchema } from '../xml-rules-check/xmlSchema.class';
import { XmlEditDelete } from './xmlEditDeleteclass';
import { XmlCursor } from '../cursor/xmlCursor.class';
import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';

export class XmlEditInsert {
  public static replaceWithText(pos: XmlCursor, value: string, rootNode: Element, xmlRules: XmlRules, xmlSchema: XmlSchema): boolean {
    if (pos === undefined) {
      return false;
    }
    if (value === '' || value === undefined || value == null) {
      return false;
    }

    if (pos.isEmptySelection() === false) {
      if (XmlEditDelete.deleteSelection(pos, rootNode, xmlRules) === false) {
        return false;
      }
    }

    return XmlEditInsert.insertText(pos.EndPos, value, rootNode, xmlRules, xmlSchema);
  }

  public static insertText(pos: XmlCursorPos, value: string, rootNode: Element, xmlRules: XmlRules, xmlSchema: XmlSchema): boolean {
    if (pos === undefined) {
      return false;
    }

    if (value === '' || value === undefined || value == null) {
      return false;
    }

    switch (pos.PosAtNode) {
      case XMLCursorPositions.CursorOnCompleteNode:
        let textAllowed = XmlEditInsert.isTextAllowedInParentNode(pos, xmlSchema);
        if (textAllowed === true) {
          const newTextNode = pos.ActualNode.ownerDocument.createTextNode(value);
          pos.ActualNode.parentElement.insertBefore(newTextNode, pos.ActualNode);
          pos.ActualNode.parentElement.removeChild(pos.ActualNode);
          const nextSibling = DomDummyNodeManager.getNextSibling(newTextNode);
          if (nextSibling) {
            pos.SetCursor(nextSibling, XMLCursorPositions.CursorInFrontOfNode);
          } else {
            pos.SetCursor(newTextNode, XMLCursorPositions.CursorBehindNode);
          }
          return true;
        } else {
          return false;
        }

      case XMLCursorPositions.CursorBehindNode:
        if (pos.ActualNode.nodeType === Node.TEXT_NODE) {
          pos.ActualNode.textContent = pos.ActualNode.textContent + value;
          return true;
        } else {
          textAllowed = XmlEditInsert.isTextAllowedInParentNode(pos, xmlSchema);
          if (textAllowed === true) {
            const newTextNode = pos.ActualNode.ownerDocument.createTextNode(value);
            pos.ActualNode.parentElement.insertBefore(newTextNode, pos.ActualNode.nextSibling); // inserts the new node after the actual node
            return true;
          } else {
            return false;
          }
        }

      case XMLCursorPositions.CursorInFrontOfNode:
        if (pos.ActualNode.nodeType === Node.TEXT_NODE) {
          pos.ActualNode.textContent = value + pos.ActualNode.textContent;
          return true;
        } else {
          textAllowed = XmlEditInsert.isTextAllowedInParentNode(pos, xmlSchema);
          if (textAllowed === true) {
            const newTextNode = pos.ActualNode.ownerDocument.createTextNode(value);
            pos.ActualNode.parentElement.insertBefore(newTextNode, pos.ActualNode);
            return true;
          } else {
            return false;
          }
        }

      case XMLCursorPositions.CursorInEmptyNode:
        textAllowed = new XmlEditRuleCheckTextInsert(xmlSchema.xsdNodes).isTextAllowedAtThisCursorPos(pos);
        if (textAllowed === true) {
          const newTextNode = pos.ActualNode.ownerDocument.createTextNode(value);
          pos.ActualNode.appendChild(newTextNode);
          return true;
        } else {
          return false;
        }

      case XMLCursorPositions.CursorInsideTextNode:
        const text = pos.ActualNode.textContent;
        pos.ActualNode.textContent = text.substr(0, pos.PosInTextnode) + value + text.substr(pos.PosInTextnode, text.length);
        pos.SetCursor(pos.ActualNode, XMLCursorPositions.CursorInsideTextNode, pos.PosInTextnode + 1);
        break;

      default:
        throw new Error(`String.Format("XmlEditInsert.insert: unknown CursorPos  ${pos.getDebugDescription()}`);
    }

    return true;
  }

  private static isTextAllowedInParentNode(pos: XmlCursorPos, xmlSchema: XmlSchema): boolean {
    const parentNode = pos.ActualNode.parentElement;
    const parentCursorPos = pos.clone();
    parentCursorPos.SetCursor(parentNode, XMLCursorPositions.CursorInEmptyNode);
    return new XmlEditRuleCheckTextInsert(xmlSchema.xsdNodes).isTextAllowedAtThisCursorPos(parentCursorPos);
  }
}
